// eslint-disable-next-line import/prefer-default-export
export const EDIT_USER_PROFILE_SOURCES = {
  SCHEDULING: 'SCHEDULING',
  UNKNOWN: 'UNKNOWN',
  SETTINGS: 'SETTINGS',
};
// eslint-disable-next-line import/prefer-default-export
export const EDIT_CLIENT_PROFILE_SOURCES = {
  SCHEDULING: 'SCHEDULING',
  UNKNOWN: 'UNKNOWN',
  CLIENTS: 'CLIENTS',
};

export const NOTIFICATION_ENTRY_POINTS = {
  TOAST: 'toast',
  NOTIFICATION_CENTER: 'notification_center',
  PUSH: 'push',
  UNKNOWN: 'unknown',
};

export const CANCELLED_APPOINTMENT_DESTINATIONS = {
  MY_SCHEDULE: 'my_schedule',
  SCHEDULING: 'scheduling',
};
